import React from 'react';
import { render } from 'react-dom';
import Calendar from '~react/components/Calendar';
import { getJsonDataFromDataAttribute } from '~utils/json';

document.addEventListener('DOMContentLoaded', () => {
    const calendarApp: HTMLElement | null = document.getElementById('calendarApp');

    if (null === calendarApp) {
        return;
    }

    render(<Calendar config={getJsonDataFromDataAttribute(calendarApp.getAttribute('data-calendar'))} />, calendarApp);
});
